import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface PortfolioProject {
  id: string;
  title: string;
  description: string | null;
  category: string;
  color: string | null;
  image_url: string;
  sort_order: number;
}

export const usePortfolioProjects = (categoryFilter: string, exact = false) => {
  const [projects, setProjects] = useState<PortfolioProject[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      let query = supabase
        .from("portfolio_projects")
        .select("*");
      
      if (exact) {
        query = query.eq("category", categoryFilter);
      } else {
        query = query.like("category", `${categoryFilter}%`);
      }
      
      const { data } = await query
        .order("sort_order", { ascending: true })
        .order("created_at", { ascending: false });
      setProjects((data as PortfolioProject[]) || []);
      setLoading(false);
    };
    fetchProjects();
  }, [categoryFilter, exact]);

  return { projects, loading };
};
